import { XMLParser, XMLBuilder } from 'fast-xml-parser'

const parserOptions = {
  ignoreAttributes: false,
  attributeNamePrefix: "@_",
  parseAttributeValue: true,
  allowBooleanAttributes: true,
  preserveOrder: true,
  compact: true
}

export default class {
  constructor() {
    this.parser = new XMLParser(parserOptions)
    this.builder = new XMLBuilder(parserOptions)
  }

  rxml(sourceUrl, callback) {
    const xhr = new XMLHttpRequest()
    xhr.open("GET", sourceUrl, true)
    xhr.onload = function() {
      if (this.status == 200) {
        callback(xhr.responseText)
      } else {
        console.warn('Cannot receive the result of the svg request.')
        callback(null)
      }
    }
    xhr.send()
  }

  rxml2js(sourceUrl, callback) {
    this.rxml(sourceUrl, xmlstring => {
      callback(this.parser.parse(xmlstring))
    })
  }

  rxml2json(sourceUrl, callback) {
    this.rxml(sourceUrl, xmlstring => {
      callback(JSON.stringify(this.parser.parse(xmlstring)))
    })
  }

  xml2js(xml) {
    return this.parser.parse(xml)
  }

  dom2js(svg) {
    const xmlString = new XMLSerializer().serializeToString(this.dom2xmlDoc(svg))
    return this.parser.parse(xmlString)
  }

  dom2json(svg) {
    const xmlString = new XMLSerializer().serializeToString(this.dom2xmlDoc(svg))
    return JSON.stringify(this.parser.parse(xmlString))
  }

  dom2xmlString(svg, self = false) {
    let xmlString = ''
    try {
      xmlString = new XMLSerializer().serializeToString(self ? svg : this.dom2xmlDoc(svg))
    } catch(e) {
      return ''
    }
    return xmlString
  }

  dom2xmlDoc(svg) {
    let html_ = ''
    try {
      html_ = svg.html()
    } catch(e) {
      return ''
    }
    return new DOMParser().parseFromString(html_, "application/xml")
  }

  xmlString2xmlDoc(xmlString) {
    return new DOMParser().parseFromString(xmlString, "application/xml")
  }

  xmlString2dom(xmlString) {
    return this.xmlString2xmlDoc(xmlString).documentElement
  }
}
